import { render, staticRenderFns } from "./MainApp.vue?vue&type=template&id=4edabcdf&scoped=true&"
import script from "./MainApp.vue?vue&type=script&lang=js&"
export * from "./MainApp.vue?vue&type=script&lang=js&"
import style0 from "./MainApp.vue?vue&type=style&index=0&id=4edabcdf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4edabcdf",
  null
  
)

export default component.exports